import React from 'react';
import { SendIcon } from './icons';
import { useMessageComposerHasSendableData } from './hooks';
export const SendButton = ({ sendMessage, ...rest }) => {
    const hasSendableData = useMessageComposerHasSendableData();
    return (React.createElement("button", { "aria-label": 'Send', className: 'str-chat__send-button', "data-testid": 'send-button', disabled: !hasSendableData, onClick: sendMessage, type: 'button', ...rest },
        React.createElement(SendIcon, null)));
};
